import { useCurrentTime } from '@/hooks/useCurrentTime';

export default function Clock() {
  const time = useCurrentTime({ format: '24h', updateSeconds: true });
  const date = new Date();
  const formattedDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="flex flex-col items-center">
        <div className="font-mono font-extrabold text-5xl bg-gradient-to-br from-primary-500 to-primary-700 bg-clip-text text-transparent animate-pulse">
          {time.formatted}
        </div>
        <div className="mt-2 text-sm font-normal text-gray-600 dark:text-gray-400 tracking-widest">
          {formattedDate}
        </div>
      </div>
      <div className="mt-2 text-xs text-gray-500 dark:text-gray-500 font-light">
        Local time
      </div>
    </div>
  );
}